import React, { FC } from 'react';

import translate from '../../../../../i18n/translate';
import ButtonControl from '../ButtonControl';

type Props = {
  isActive: boolean;
  onClick: () => void;
};

/**
 * The button for styling the selected text, making it italic
 *
 * @param props          The props passed to the component
 * @param props.isActive Whether the control is active
 * @param props.onClick  Button click callback
 * @returns              The component itself
 */
const ButtonStyleTextItalic: FC<Props> = props => {
  const label = translate('COMPOSE__STYLE__ITALIC');
  return <ButtonControl iconName="italic" label={label} {...props} />;
};

export default ButtonStyleTextItalic;
